const youtubeAuthApiUrl = "https://accounts.google.com/o/oauth2/v2/auth";

const youtubeSettings = {
  dev: {
    youtubeAuthApiUrl,
    client_id: process.env.REACT_APP_YOUTUBE_CLIENT_ID ?? "657186336300-edbeck0dmjoqt57mn9cq7fu331enlqlj.apps.googleusercontent.com",
    redirect_uri: "http://localhost:3000/callbacks/youtube",
    scope: "https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/youtube.upload",
    response_type: "code",
    access_type: "offline",
    prompt: "consent",
  },
  stage: {
    youtubeAuthApiUrl,
    client_id: process.env.REACT_APP_YOUTUBE_CLIENT_ID ?? "657186336300-edbeck0dmjoqt57mn9cq7fu331enlqlj.apps.googleusercontent.com",
    redirect_uri: "https://stage.mymediaplanner.com/callbacks/youtube",
    scope: "https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/youtube.upload",
    response_type: "code",
    access_type: "offline",
    prompt: "consent",
  },
  prod: {
    youtubeAuthApiUrl,
    client_id: process.env.REACT_APP_YOUTUBE_CLIENT_ID ?? "657186336300-edbeck0dmjoqt57mn9cq7fu331enlqlj.apps.googleusercontent.com",
    redirect_uri: "https://mymediaplanner.com/callbacks/youtube",
    scope: "https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/youtube.upload",
    response_type: "code",
    access_type: "offline",
    prompt: "consent",
  },
};

const getYoutubeSettings = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "stage":
      return youtubeSettings.stage;
    case "prod":
      return youtubeSettings.prod;
    default:
      return youtubeSettings.dev;
  }
};

export default getYoutubeSettings;
